var nodeInspector = require('./nodeInspector');
var nodeModifier = require('./nodeModifier');
var prevMutations;

const c2dExports: any = {};

function observe(startNode, observeMutations, skipInspect) {
  let observer;

  function inspectNode(node) {
    if (!skipInspect && node.nodeType !== 8 && document.body.contains && document.body.contains(node)) {
      if (['TEXTAREA', 'INPUT'].indexOf(node.tagName) !== -1 && /<vg-is>/.test(node.textContent)) { //CAC-144 inspired
        node.value = node.textContent.replace(/<vg-is[^>]*>.*<vg-is-orig[^>]*>(.*)<\/vg-is-orig>.*<\/vg-is>/gm, '$1');
      }
      nodeInspector.recurseDomChildren(node);
    }
  }

  function mutationsHandler(mutations) {
    [].slice.call(mutations).forEach(function(mutation) {
      if (mutation.type === 'childList') {
        // tslint:disable-next-line: max-line-length
        if (mutation.target && mutation.target.tagName && ['VG-IS', 'VG-IS-DIAL', 'VG-IS-ORIG', 'GU-SC', 'GU-SC-DIAL', 'GU-SC-ORIG'].indexOf(mutation.target.tagName) !== -1) {
          if (mutation.target.tagName === 'GU-SC' && mutation.target.childNodes.length === 2) {
            if (mutation.target.childNodes[0].tagName === 'VG-SC-DIAL' && mutation.target.childNodes[1].tagName === 'VG-SC-ORIG') {
              if (mutation.target.childNodes[0].textContent !== mutation.target.childNodes[1].textContent) {
                nodeModifier.revert(mutation.target);
              }
            }
          }
          return;
        }
        [].slice.call(mutation.addedNodes).forEach(inspectNode);
      } else if (mutation.target && mutation.type === 'characterData' && mutation.target.nodeType !== 8) { // ignore comment nodes early
        if (mutation.target.nextSibling) {
          if (mutation.target.nextSibling.className === 'trx-phone-number') return;
        }
        if (mutation.target.parentNode && mutation.target.parentNode.tagName === 'VG-IS-ORIG' && mutation.target.parentNode.parentNode) {
          nodeModifier.revert(mutation.target.parentNode.parentNode);
        } else if (
          mutation.target.parentNode && mutation.target.parentNode.tagName === 'A' 
          && mutation.target.parentNode.parentNode && mutation.target.parentNode.parentNode.tagName === 'VG-IS-ORIG' 
          && mutation.target.parentNode.parentNode.parentNode
        ) {
          nodeModifier.revert(mutation.target.parentNode.parentNode.parentNode);
        } else {
          inspectNode(mutation.target);
        }
      }
    });
  }

  function toggleObserverListener(enabled) {
    if (!observer) {
      observer = new MutationObserver(mutationsHandler);
    }
    observer.disconnect();
    if (enabled) {
      observer.observe(startNode, {
        attributes: false,
        childList: true,
        subtree: true,
        characterData: true
      });
      skipInspect = false;
      inspectNode(startNode);
    } else {
      nodeInspector.revertDomChildren(startNode);
    }
  }
  c2dExports.toggleObserverListener = toggleObserverListener;

  if (observeMutations) {
    toggleObserverListener(true);
  }

  return inspectNode(startNode);
}
c2dExports.observe = observe;

module.exports = c2dExports;